import React, { useEffect, useRef } from "react";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
  GridFilterChangeEvent,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { FiEdit } from "react-icons/fi";
import { MdDelete, MdKeyboardBackspace, MdPrint } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { BsBookmarkPlusFill } from "react-icons/bs";
import { TbMailDollar, TbMailShare } from "react-icons/tb";
import { RxCrossCircled } from "react-icons/rx";
import { checkAcessRights } from "../../../_helper/helper";
import { DELETE_ACCESS, EDIT_ACCESS } from "../../../_contstants/common";
import IconButton from "../../../components/common/IconButton";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  deleteFITBooking,
  getAllFITBookings,
  sendFITBookingByEmail,
} from "../../fitbooking/services/FITBooking.services";
import {
  closeDialog,
  openDialog,
} from "../../../components/dialog/dialogSlice";
import {
  clearFITBookingID,
  setFITBookingID,
  setFITBookingPaymentBifurcation,
} from "../../fitbooking/FITBookingSlice";
import { LoadingPanel } from "../../../components/layout/Loading";
import AppDialog, {
  DialogCloseButton,
} from "../../../components/dialog/Dialog";
import { getDashboardFITBookings } from "../services/dashboard.services";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";

const DashboardFITBookings: React.FC = () => {
  const dispatch = useAppDispatch();
  const dateFilter = useAppSelector((state) => state.dashboard.dateFilter);
  const navigate = useNavigate();

  console.log(dateFilter)

  useEffect(() => {
    const payload = {
      FromDate: dateFilter?.FromDate ? dateFilter?.FromDate : "",
      ToDate: dateFilter?.ToDate ? dateFilter?.ToDate : "",
      SectorID: dateFilter?.SectorID ? dateFilter?.SectorID : null,
    };
    dispatch(getDashboardFITBookings(payload));
  }, [dateFilter]);

  return (
    <>
      <DeleteFITBookingDialog />
      <EmailConfirmationDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0px 20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconButton
              fillMode="solid"
              title="Back"
              onClick={() => navigate(-1)}
              icon={MdKeyboardBackspace}
              iconClassName="absolute-position"
              style={{ height: 30 }}
              iconStyle={{ fontSize: "20px" }}
            />
            <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
              FIT Booking List
            </Typography.h4>
          </div>
        </GridLayoutItem>
        <GridLayoutItem>
          <FITBookingGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const FITBookingGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isEditAccess = checkAcessRights("/fitbooking", EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights("/fitbooking", DELETE_ACCESS);

  const loading = useAppSelector((state) => state.dashboard.loading);
  const DashboardFITBookingList = useAppSelector(
    (state) => state.dashboard.DashboardFITBookingList
  );

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All"
        ? DashboardFITBookingList.length
        : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: any) => {
    const handleEdit = (item: any) => {
      navigate("/fitbooking/edit", {
        state: {
          FITBookingID: item?.ID,
          SectorID: item?.SectorID,
        },
      });
    };
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteFITBooking"));
      dispatch(setFITBookingID(ID));
    };

    const handleSendEmail = async (ID: number, IsWOBifurcation: boolean) => {
      if (ID) {
        dispatch(openDialog("emailConfirmationDialog"));
        dispatch(setFITBookingID(ID));
        dispatch(setFITBookingPaymentBifurcation(IsWOBifurcation));
      }
    };

    const handlePrint = async (PackageBooking_GUID: string) => {
      if (PackageBooking_GUID) {
        window.open(`/fitbooking/view/${PackageBooking_GUID}`);
      }
    };

    const handleBookingCancel = async (TourBookingNo: number, ID: number) => {
      if (TourBookingNo) {
        navigate(`/fitbookingcancellation`, {
          state: {
            TourBookingNo,
            PackageBookingID: ID,
          },
        });
      }
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style, display: "flex" }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => {
              handleEdit(props.dataItem);
            }}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Send Email"
          themeColor="success"
          onClick={() => handleSendEmail(props.dataItem.ID, false)}
          icon={TbMailDollar}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Send Email"
          themeColor="success"
          onClick={() => handleSendEmail(props.dataItem.ID, true)}
          icon={TbMailShare}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Print"
          themeColor="dark"
          onClick={() => handlePrint(props.dataItem.PackageBooking_GUID)}
          icon={MdPrint}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
        {!props.dataItem.CancelledStatus && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Cancel Booking"
            className="color-red"
            onClick={() =>
              handleBookingCancel(
                props.dataItem.TourBookingNo,
                props.dataItem.ID
              )
            }
            icon={RxCrossCircled}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 8 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props.tdProps} />
  );

  const ListingButtonCell = (props: any) => {
    const handleBookings = (ID: number) => {
      navigate("/tourbooking", { state: { FITBookingID: ID } });
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Bookings"
          themeColor="tertiary"
          onClick={() => handleBookings(props.dataItem.ID)}
          icon={BsBookmarkPlusFill}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "20px" }}
        />
      </td>
    );
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 152px)" }}
        className="responsive-table"
        filterable={true}
        filter={filter}
        resizable={true}
        reorderable={true}
        data={
          filter
            ? filterBy(DashboardFITBookingList, filter).slice(
                page.skip,
                page.take + page.skip
              )
            : DashboardFITBookingList.slice(page.skip, page.take + page.skip)
        }
        onFilterChange={handleFilterChange}
        skip={page.skip}
        take={page.take}
        total={DashboardFITBookingList.length}
        pageable={{
          buttonCount: 5,
          pageSizes: [5, 10, 15, "All"],
          pageSizeValue: pageSizeValue,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="TourBookingNo"
          title="Booking No."
          width={120}
          cells={{
            data: (props: any) => (
              <td>
                {isEditAccess ? (
                  <div
                    className="hoverableName"
                    onClick={() =>
                      navigate("/fitbooking/edit", {
                        state: {
                          FITBookingID: props.dataItem?.ID,
                          SectorID: props.dataItem?.SectorID,
                        },
                      })
                    }
                  >
                    {props.dataItem?.TourBookingNo}
                  </div>
                ) : (
                  <div className="normalName">
                    {props.dataItem?.TourBookingNo}
                  </div>
                )}
              </td>
            ),
          }}
        />
        <Column
          field="BookingDate"
          title="Booking Date"
          width={150}
          cells={{
            data: (props: any) => <td>{props.dataItem?.BookingDate}</td>,
          }}
        />
        <Column
          field="TourStartDate"
          title="Tour Date"
          width={120}
          cells={{
            data: (props: any) => (
              <td>
                <p className="m-0">{props.dataItem?.TourStartDate}</p>
                <p className="m-0">{props.dataItem?.TourEndDate}</p>
              </td>
            ),
          }}
        />
        <Column
          field="FirstName"
          title="Name"
          width={300}
          cells={{
            data: (props: any) => (
              <td>
                {props.dataItem?.FirstName} {props.dataItem?.LastName}
              </td>
            ),
          }}
        />
        <Column
          field="MobileNo"
          title="Mobile No."
          width={200}
          cells={{ data: (props: any) => <td>{props.dataItem?.MobileNo}</td> }}
        />
        <Column
          field="EmailID"
          title="Email ID"
          width={300}
          cells={{ data: (props: any) => <td>{props.dataItem?.EmailID}</td> }}
        />
        <Column
          field="SectorName"
          title="Sector"
          width={200}
          cells={{
            data: (props: any) => <td>{props.dataItem?.SectorName}</td>,
          }}
        />
        <Column
          field="CreatedByEmployeeName"
          title="Created By"
          width={200}
          cells={{
            data: (props: any) => (
              <td>{props.dataItem?.CreatedByEmployeeName}</td>
            ),
          }}
        />
        {false && (
          <Column
            field="ID"
            title="Details"
            cells={{ data: ListingButtonCell }}
            width={"110px"}
            filterable={false}
            locked={true}
          />
        )}
        {(isEditAccess || isDeleteAccess) && (
          <Column
            field="ID"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"200px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

const EmailConfirmationDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.FITBooking.loading);
  const gridRef = useRef<any>(null);
  const FITBookingID = useAppSelector((state) => state.FITBooking.FITBookingID);
  const IsWOBifurcation = useAppSelector(
    (state) => state.FITBooking.IsWOBifurcation
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const handleConfirm = async (ID: number | null) => {
    if (ID) {
      const res = await dispatch(
        sendFITBookingByEmail({ ID: +ID, Is_Bifurcation: IsWOBifurcation })
      );
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(closeDialog());
      }
    }
  };

  return (
    <>
      {dialogName === "emailConfirmationDialog" && (
        <AppDialog>
          <>
            {loading && <LoadingPanel gridRef={gridRef} />}
            <Typography.h5>{"Email Confirmation"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to send Email?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="primary" />
                <Button
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={() => handleConfirm(FITBookingID)}
                  type="button"
                >
                  Confirm
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const DeleteFITBookingDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const FITBookingID = useAppSelector((state) => state.FITBooking.FITBookingID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const FITBookingFilterDetails = useAppSelector(
    (state) => state.FITBooking.FITBookingFilterDetails
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const UserIDString = useAppSelector(
    (state) => state.login.loginDetails?.UserID
  );
  const UserID = parseInt(UserIDString);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteFITBooking(ID));

      if (response.meta.requestStatus === "fulfilled") {
        // dispatch(setCurrentPage(0));
        dispatch(
          getAllFITBookings({
            ...FITBookingFilterDetails,
            CreatedBy: UserID,
            Limit: +pageLimit,
            Skip: +currentPage * +pageLimit,
          })
        );
        dispatch(closeDialog());
        dispatch(clearFITBookingID());
      } else {
        dispatch(
          getAllFITBookings({
            ...FITBookingFilterDetails,
            CreatedBy: UserID,
            Limit: +pageLimit,
            Skip: +currentPage * +pageLimit,
          })
        );
        dispatch(closeDialog());
        dispatch(clearFITBookingID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteFITBooking" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete FIT Booking"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this FIT Booking?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(FITBookingID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default DashboardFITBookings;
